<template>
  <div v-if="data" class="footnotes">
    <p v-for="(footnote, key) in [].concat(data.list)" :key="key">
      <span class="footnote-number">{{ key + 1 }})</span>
      {{ footnote }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Fineprint',
  props: {
    'data': {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// BlockFootnotes.vue?45e0b842